import {assign} from 'lodash';
import {rasterTrafficFlowLayer} from '../../endpoints';
import rasterStylesFactory from './rasterStylesFactory';

const LAYER_NAMES = {
    ABSOLUTE: 'tomtomRasterTrafficFlowAbsolute',
    RELATIVE: 'tomtomRasterTrafficFlowRelative',
    RELATIVE_DELAY: 'tomtomRasterTrafficFlowRelativeDelay',
    REDUCED_SENSITIVITY: 'tomtomRasterTrafficFlowReducedSensitivity',
    RELATIVE0: 'tomtomRasterTrafficFlowRelative0',
    RELATIVE0_DARK: 'tomtomRasterTrafficFlowRelative0Dark'
};

function styleChooser(thickness) {
    const options = {
        'tileSize': 512
    };
    return {
        ABSOLUTE: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.ABSOLUTE,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'absolute', 'thickness': thickness })
        ),
        RELATIVE: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.RELATIVE,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'relative', 'thickness': thickness})
        ),
        RELATIVE_DELAY: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.RELATIVE_DELAY,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'relative-delay', 'thickness': thickness})
        ),
        REDUCED_SENSITIVITY: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.REDUCED_SENSITIVITY,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'reduced-sensitivity'})
        ),
        RELATIVE0: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.RELATIVE0,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'relative0'})
        ),
        RELATIVE0_DARK: rasterStylesFactory(
            'traffic-flow',
            LAYER_NAMES.RELATIVE0_DARK,
            rasterTrafficFlowLayer,
            assign(options, {'{style}': 'relative0-dark'})
        )
    };
}

export default function(thickness, style) {
    return styleChooser(thickness)[style.toUpperCase().replace('-', '_')];
}



// WEBPACK FOOTER //
// ./map/tier/styleParts/rasterTrafficFlowTiles.js